export default __webpack_public_path__ + "static/media/SconeMixProductInfo5.0e7e8b8a.jpg";